<template>
    <div>
        <input :id="item_id"
               :name="item_name"
               class="form-control"
               type="text"
               v-model="item.amount"
        >
        <span v-if="formatLess(item.amount) >= 10">
            <span v-text="Num2persian(Math.floor(formatLess(item.amount) / 10))"></span>&nbsp;
            <span v-text="$t('label.toman')"></span>
        </span>
    </div>
</template>

<script>
    import Num2persian from 'num2persian';

    export default {
        data() {
            return {
                Num2persian,
            };
        },
        props: {
            item: Object,
            item_name: String,
            item_id: String,
            item_index: {
                type: Number,
                required: false,
            },
            onAmountChange: {
                type: Function,
                default: null,
            },
        },
        watch: {
            'item.amount'(newValue, oldValue) {
                if (this.formatLess(newValue) !== this.formatLess(oldValue) && this.formatLess(newValue) > 0) {
                    this.item.amount = this.moneyFormat(newValue);
                    if (typeof this.onAmountChange === 'function') {
                        this.onAmountChange(this.item_index);
                    }
                }
            },
        },
        methods: {
            formatLess(price) {
                if (price == null || price === '' || price === 0) {
                    return 0;
                }

                return price.replace(/,/g, '');
            },
            moneyFormat(price) {
                price = this.formatLess(price);
                const pieces = parseFloat(price).toFixed(0).split('');
                let len = pieces.length;

                while ((len -= 3) > 0) {
                    pieces.splice(len, 0, ',');
                }

                return pieces.join('');
            },
        },
    }
</script>
